module.exports = __webpack_public_path__ + "static/lesson_8-b9043514e52711f0129c4e1bcea5b93a.png";